/**
 * Brand logo URL helpers (client-safe).
 *
 * When a shop serves its wordmark from the recolourable route
 * (/brand-logo.svg, backed by Shop.brandLogoSvg), callers can ask for the
 * light or dark rendition; any other logo URL (uploaded PNG) is returned
 * unchanged.
 */
export type LogoTone = "dark" | "light";

export function brandLogoSrc(url: string | null | undefined, tone: LogoTone): string | null {
  if (!url) return null;
  if (!/\/brand-logo\.svg(\?|$)/.test(url)) return url;
  const base = url.replace(/\?.*$/, "");
  return tone === "light" ? `${base}?tone=light` : base;
}
